export function formatCurrency(value) {
    const cleanedValue = value.replace(/[^\d,]/g, '').replace(',', '.');
    const currencyValue = parseFloat(cleanedValue);
    
    if (isNaN(currencyValue)) {
        return '';
    }
    return "R$ " + currencyValue.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
}

export function parseCurrency(value) {
    if (!value) return '';
    const number = value.replace('R$ ', '').replace(/\./g, '').replace(',', '.');
    return number;
}

export function handleInput(value) {
    return value.replace(/[^0-9,]/g, '').replace(/,(?=.*?,)/g, '');
}
